import { ErrorMessage } from 'constants/error-message.enum';
import { String } from 'typescript-string-operations';
import { postcodeRegex, priceRegex } from 'utils/validation';
import { CatalogueFormField } from './catalogue-form-field.enum';

const titleMaxLength = 70;
const flockNameMaxLength = 35;
const propertyNameMaxLength = 35;
const addressMaxLength = 35;
const townMaxLength = 35;
const nameMaxLength = 70;
const saleDescriptionMaxLength = 1000;
const dosesMaxLength = 12;

/**
 * Form validation config for the Sale and Semen catalogues.
 */
export const catalogueFormValidation = {
  [CatalogueFormField.Title]: {
    required: ErrorMessage.RequiredField,
    maxLength: {
      value: titleMaxLength,
      message: String.Format(ErrorMessage.FieldMaxLength, titleMaxLength),
    },
  },
  [CatalogueFormField.FlockName]: {
    required: ErrorMessage.RequiredField,
    maxLength: {
      value: flockNameMaxLength,
      message: String.Format(ErrorMessage.FieldMaxLength, flockNameMaxLength),
    },
  },
  [CatalogueFormField.SaleStartDate]: {
    required: ErrorMessage.RequiredField,
  },
  [CatalogueFormField.SaleEndDate]: {
    required: ErrorMessage.RequiredField,
  },
  [CatalogueFormField.ListingStartDate]: {
    required: ErrorMessage.RequiredField,
  },
  [CatalogueFormField.PropertyName]: {
    maxLength: {
      value: propertyNameMaxLength,
      message: String.Format(ErrorMessage.FieldMaxLength, propertyNameMaxLength),
    },
  },
  [CatalogueFormField.Address]: {
    maxLength: {
      value: addressMaxLength,
      message: String.Format(ErrorMessage.FieldMaxLength, addressMaxLength),
    },
  },
  [CatalogueFormField.Town]: {
    required: ErrorMessage.RequiredField,
    maxLength: {
      value: townMaxLength,
      message: String.Format(ErrorMessage.FieldMaxLength, townMaxLength),
    },
  },
  [CatalogueFormField.Postcode]: {
    required: ErrorMessage.PostcodePattern,
    pattern: {
      value: postcodeRegex,
      message: ErrorMessage.PostcodePattern,
    },
  },
  [CatalogueFormField.State]: {
    required: ErrorMessage.RequiredField,
  },
  [CatalogueFormField.Country]: {
    required: ErrorMessage.RequiredField,
  },
  [CatalogueFormField.ContactName]: {
    required: ErrorMessage.RequiredField,
    maxLength: {
      value: nameMaxLength,
      message: String.Format(ErrorMessage.FieldMaxLength, nameMaxLength),
    },
  },
  [CatalogueFormField.SaleDescription]: {
    maxLength: {
      value: saleDescriptionMaxLength,
      message: String.Format(ErrorMessage.FieldMaxLength, saleDescriptionMaxLength),
    },
  },
  [CatalogueFormField.AnimalPrice]: {
    pattern: {
      value: priceRegex,
      message: ErrorMessage.PriceInvalidFormat,
    },
  },
  [CatalogueFormField.Doses]: {
    maxLength: {
      value: dosesMaxLength,
      message: String.Format(ErrorMessage.FieldMaxLength, dosesMaxLength),
    },
  },
  [CatalogueFormField.Animals]: {
    required: ErrorMessage.UploadRequiredTemplate,
  },
};
